import * as React from 'react';
import { Instance } from 'mobx-state-tree';
import { BlackPoint } from '../../store/models/BlackPoint';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import BlackPointDetails from './BlackPointDetails';
import { BlackPointStatus } from '../../store/models/BlackPointStatus';
import { BlackPointSearchCriteria } from '../../store/BlackPointStore';
import { TLCode } from '../../common/enums';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { DateWithDayAndMonthStrFormat } from '../../store/utils';
import moment from 'moment';

interface BlackPointListProps extends WithTranslateProps {
  blackPointList: Array<Instance<typeof BlackPoint>>;
  changeStatus: (data: any) => void;
  statusList: Array<Instance<typeof BlackPointStatus>>;
  getStatusById: (id: number) => Instance<typeof BlackPointStatus>;
  getPharmacyById: (id: number) => any;
  searchCriteria: Instance<typeof BlackPointSearchCriteria>;
  locale: string;
  userRoles: string[];
}

class BlackPointList extends React.Component<BlackPointListProps> {
  render() {
    const { blackPointList, searchCriteria, getPharmacyById, locale } = this.props;
    const pharmacy = searchCriteria.pharmacyId !== null ? getPharmacyById(searchCriteria.pharmacyId) : null;

    return (
      <div>
        <h3>
          {searchCriteria.pharmacyId === null &&
            searchCriteria.date === null &&
            (searchCriteria.treated === null || searchCriteria.treated === false) && (
              <TranslatedMessage id={TLCode.BLACKPOINTS_TitleNoCriteria} />
            )}
          {searchCriteria.pharmacyId === null &&
            searchCriteria.date === null &&
            (searchCriteria.treated === null || searchCriteria.treated === true) && (
              <TranslatedMessage id={TLCode.BLACKPOINTS_TitleToProcessed} />
            )}
          {(searchCriteria.pharmacyId !== null || searchCriteria.date !== null) && (
            <div>
              <TranslatedMessage id={TLCode.BLACKPOINTS_Title} />
              &nbsp;
              {searchCriteria.pharmacyId !== null && pharmacy != null && pharmacy.name + ' '}
              {searchCriteria.date != null &&
                moment(searchCriteria.date)
                  .locale(locale)
                  .format(DateWithDayAndMonthStrFormat)}
            </div>
          )}
        </h3>
        {blackPointList.map((blackPoint) => (
          <BlackPointDetails key={blackPoint.blackPointId} blackPoint={blackPoint} {...this.props} />
        ))}
        {blackPointList.length === 0 && <TranslatedMessage id={TLCode.BLACKPOINTS_EmptyList} />}
      </div>
    );
  }
}

export default withTranslate(BlackPointList);
